import { TApiDataStateSlice } from "@/redux/store.types";

export const $PaymentModuleName = "payment";

export type TPaymentState = TApiDataStateSlice<{}>;
